import { getUrlParam, getValue } from '@/libs/functions/getValue'
import handleBankJS from './bankJs'
import { getStorage } from '@/libs/functions/onStorage'

export type LoadJSOptions =
  | { defer: true; async?: never }
  | { async: true; defer?: never }

// 动态引入js
export function loadJS(
  url: string,
  callback?: Function,
  options?: LoadJSOptions,
) {
  try {
    const domScript = document.createElement('script') as any
    domScript.src = url
    if (options?.defer) {
      domScript.defer = true
    } else if (options?.async) {
      domScript.async = true
    }
    domScript.onload = domScript.onreadystatechange = function () {
      if (
        !this.readyState ||
        'loaded' === this.readyState ||
        'complete' === this.readyState
      ) {
        callback && callback()
        this.onload = this.onreadystatechange = null
        // this.parentNode.removeChild(this)
      }
    }
    // 错误处理，为了不影响页面加载，都调用success回调
    domScript.onerror = function (error: any) {
      callback && callback(error)
      this.onerror = null
      // this.parentNode.removeChild(this)
    }
    document.getElementsByTagName('body')[0].appendChild(domScript)
  } catch (error) {
    callback && callback(error)
    console.log('error', error)
  }
}

export const loadBankJS = async () => {
  return new Promise(async (resolve, reject) => {
    // 获取channel
    let channel = getUrlParam('channel') || getStorage('channel')

    // 民生的channel是特殊获取的
    if (!channel) {
      // 截取redirectUrl后面的参数
      const redirectUrl = window.location.href.split('redirectUrl')[1] || ''
      // 截取redirectUrl后面的参数的channel
      const afterRedirectUrlChannel = getUrlParam(
        'channel',
        decodeURIComponent(redirectUrl),
      )
      channel = afterRedirectUrlChannel
    }

    // 增加行方特殊js
    const apiObj: any = {
      cmbc: './js/CMBCJSBridge.min.js', // 民生银行
      msbank:
        'https://rs.creditcard.cmbc.com.cn/mmc/page/threePage/clientLib/msBridge-1.4.0.min.js', // 民生出游
    }
    if (!apiObj[channel]) {
      handleBankJS() // 预防js不是通过apiObj进行引入的，比如富滇
      resolve(true)
      return
    }
    console.log(apiObj[channel])
    loadJS(apiObj[channel], () => {
      handleBankJS()
      resolve(true)
    })
  })
}

// 加载微信SDK
export const loadWXJS = async () => {
  return new Promise(async (resolve, reject) => {
    loadJS('./js/jweixin-1.3.2.js', resolve, { async: true })
  })
}

// 加载钉钉SDK
export const loadDDJS = async () => {
  return new Promise(async (resolve, reject) => {
    if (navigator.userAgent.toLowerCase().indexOf('dingtalk') > -1) {
      loadJS('https://appx/web-view.min.js', resolve)
    }
  })
}

export default loadJS
